import { useQuery } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { useApi } from "../../../hooks/useApi"

const useTradingCurrencies = () => {
  const { scientApi } = useApi()

  const { data, error, isLoading } = useQuery(
    ["trading_currencies"],
    scientApi.trading.getTradingCurrencies,
    {
      retry: 1,
      staleTime: Infinity, // Static list, no need to refresh.
    },
  )

  return {
    currencies: data,
    error: error as AxiosError,
    isLoading,
  }
}

export default useTradingCurrencies
